export const SET_AUTH_STEP = 'SET_AUTH_STEP';
export const SET_PHONE_NUMBER = 'SET_PHONE_NUMBER';
export const SET_OTP = 'SET_OTP';
export const SET_USERNAME = 'SET_USERNAME';
export const SET_AUTH_LOADING = 'SET_AUTH_LOADING';
export const SET_AUTH_ERROR = 'SET_AUTH_ERROR';
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED';
export const SET_USER_INFO = 'SET_USER_INFO';
export const RESET_AUTH = 'RESET_AUTH';
export const OPEN_LOGIN_MODAL = 'OPEN_LOGIN_MODAL';
export const CLOSE_LOGIN_MODAL = 'CLOSE_LOGIN_MODAL';
export const SET_PENDING_ROOM = 'SET_PENDING_ROOM';
